import React, { useEffect } from 'react';
import './DirectPage.scss';
import { useLocation } from 'react-router-dom';
import Logo from '../../assets/svg/Logo.svg';
import Loader from '../../components/Loader/Loader';
import { useLanguage } from '../../store/store';
import { setText } from './utils';

const DirectPage = () => {
    const location = useLocation();
    const { selectedLanguage } = useLanguage();
    const user = window.navigator.userAgent;
    const getPlatform = (user: string) => {
        return user.toLowerCase().includes('android') ? 'android' : 'iphone';
    };

    const redirectToStore = (platform: string) => {
        if (platform === 'android') {
            window.open('https://play.google.com/store/apps/details?id=is.wunder.elefant', '_top');
        } else {
            console.log(platform, 'app sore');
            window.location.href = 'https://apps.apple.com/us/app/elefant/id1614980280';
        }
    };
    useEffect(() => {
        console.log('DirectPage is loaded');
        const platform = getPlatform(user);
        redirectToStore(platform);
        return () => {
            console.log('DirectPage is unloaded');
        };
    }, [location]);

    return (
        <div className="DirectPage" data-testid="DirectPage">
            <div className="DirectPage__logo">
                <img src={Logo} alt="elefant" />
            </div>
            <div className="DirectPage__loader">
                <Loader></Loader>
            </div>
            <div className="DirectPage__text">{setText(selectedLanguage)}</div>
        </div>
    );
};

export default DirectPage;
